import './styles.scss';

import { faBars } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import React, { useEffect, useRef, useState, useCallback } from 'react';

import { NestedDragContainer } from '../../../../../components/draggable/nested-drag';
import { Dropdown } from '../../../../../components/dropdown/dropdown';
import { ISortPnlTable } from '../../../../../providers/pnl-provider';

interface Props {
  sortTable: ISortPnlTable[];
  setSortTable: React.Dispatch<React.SetStateAction<ISortPnlTable[]>>;
}

export const ReorderPnlTableMenu = (props: Props) => {
  const { sortTable, setSortTable } = props;

  const [itemsList, setItemsList] = useState(sortTable);
  const [open, setOpen] = useState(false);

  const dropdownRef = useRef<HTMLDivElement>(null);

  const onClose = () => {
    setOpen(false);
  };

  const handleOnCancel = () => {
    onClose();
  };

  const handleOnApply = useCallback(() => {
    if (itemsList.length === 0) return;

    setSortTable(itemsList);
    setOpen(false);
  }, [itemsList]);

  const handleItemsChange = (newArr: ISortPnlTable[]) => {
    setItemsList(newArr);
  };

  const handleResetToDefault = () => {};

  useEffect(() => {
    const dropdown = dropdownRef.current;
    if (!dropdown) return;

    if (open) {
      const rect = dropdown.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.top;
      const minimumDistanceToBottom = 40;

      if (spaceBelow < dropdown.clientHeight) {
        const topValue = -(dropdown.clientHeight - spaceBelow + minimumDistanceToBottom);
        dropdown.style.top = `${topValue}px`;
      }
    } else {
      dropdown.style.top = 'unset';
      dropdown.style.bottom = 'unset';
    }
  }, [open]);

  const renderResetButton = () => {
    return (
      <Button className="reset-button" onClick={handleResetToDefault}>
        Reset to default
      </Button>
    );
  };

  return (
    <div className="reorder-main-table-menu">
      <div className="reorder-main-table-menu-open" onClick={() => setOpen((prev) => !prev)}>
        <FontAwesomeIcon icon={faBars} className="icon" />
        <span>Table rows</span>
      </div>

      <Dropdown
        isOpen={open}
        setIsOpen={setOpen}
        classNames="dropdown-class"
        ref={dropdownRef}
        onClose={onClose}
      >
        <div className="content">
          <div className="menu-header">
            <span className="menu-header-title">Sort table rows</span>
            {renderResetButton()}
          </div>

          <div className="list-items">
            <NestedDragContainer items={itemsList} onItemsChange={handleItemsChange} />
          </div>

          <div className="buttons">
            <Button className="cancel-button" onClick={handleOnCancel}>
              Cancel
            </Button>
            <Button className="apply-button" onClick={handleOnApply}>
              Apply
            </Button>
          </div>
        </div>
      </Dropdown>
    </div>
  );
};
